import "./DroppableArea.scss"

import { FC, PropsWithChildren } from "react"
import cn from "classnames"

interface IDroppableAreaProps {
    isDragOver?: boolean
}

const DroppableArea: FC<PropsWithChildren<IDroppableAreaProps>> = ({
    isDragOver,
    children,
}) => {
    return (
        <div className={cn(
                "droppable-area",
                { "droppable-area--drag-over": isDragOver },
            )}>
            {children}
        </div>
    )
}

export default DroppableArea
